import type { ReactNode } from 'react';
import ToggleButton from '@rio-cloud/rio-uikit/ToggleButton';

// ToggleButton component does not give disable option. This is a quick workaround
export const ToggleButtonExtended = (props: {
    disabled: boolean;
    active: boolean;
    onClick: () => void;
    children?: ReactNode;
}) =>
    props.disabled ? (
        <ToggleButton active={props.active} onClick={props.onClick}>
            {props.children}
        </ToggleButton>
    ) : (
        <button type={'button'} className={'btn btn-default'} disabled={true}>
            {props.children}
        </button>
    );
